import BaseModelAPI from '../BaseModelAPI';

export default class RepackingControlCard extends BaseModelAPI {
	static entity = 'repackingcontrolcard';
	static entityName = 'repackingcontrolcard';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.repackingId = '';
			this.repacking = {};
			this.repackingDetailId = '';
			this.repackingDetail = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.scanById = '';
			this.scanBy = {};
			this.scanDate = '';
			this.qty = 0;
			this.qtyOriginal = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}